import { useQueryClient } from '@tanstack/react-query';

import { protocolosApi } from '../api';
import { BULK_BATCH_SIZE, BULK_MAX_CONCURRENT_BATCHES } from '../constants';
import type { BulkResponseConsolidada } from '../types';
import { orquestarBatches } from '../utils/orquestarBatches';
import { protocolosKeys } from './useProtocolos';

interface RunParams {
  uids: string[];
  facturado: boolean;
  onProgress?: (procesados: number, total: number) => void;
}

export function useBulkActualizarFacturado() {
  const queryClient = useQueryClient();

  async function run({ uids, facturado, onProgress }: RunParams): Promise<BulkResponseConsolidada> {
    const result = await orquestarBatches({
      uids,
      batchSize: BULK_BATCH_SIZE,
      maxConcurrent: BULK_MAX_CONCURRENT_BATCHES,
      procesarBatch: (batchUids) => protocolosApi.bulkActualizarFacturado(batchUids, facturado),
      onProgress,
    });
    void queryClient.invalidateQueries({ queryKey: protocolosKeys.all });
    return result;
  }

  return { run };
}
